import order from './order'
import account from './account'
import app from './app'
import user from './user'
export default {
    ...app,
    ...order,
    ...account,
    ...user
}